module.exports = __webpack_public_path__ + "img/desburocratizacao_prata.0c968101.png";